export default "__VITE_ASSET__90307550__"